import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useInnerBlocks } from "eddev/blocks"
import { GlobalBlockContext } from "../content/global"
import { useContext } from "react"

export const meta: BlockMeta = {
  title: "Feature Callout Inner",
}

export default defineBlock("section/feature-callout-inner", (props) => {
  const { isGlobalBlock } = useContext(GlobalBlockContext)
  const blocks = useInnerBlocks()
  const hasMedia = blocks.some(
    // @ts-ignore
    (block) => block.blockName === "acf/content-inline-media" || block.name === "acf/content-inline-media",
  )

  return (
    <div
      className={cn(
        "feature-callout-inner w-full h-full [&_p]:type-body-m [&_li]:type-body-m [&_p]:text-grey-2 [&_li]:text-grey-2 [&_p>strong]:text-charcoal [&_h5]:type-header-m [&_.inline-icons]:justify-start [&_.inline-icons]:gap-2 [&_.inline-icons_.inline-icon-inner-0]:md:h-5 [&_.inline-icons_.inline-icon-inner-1]:md:h-4 [&_.inline-icon-inner-0]:md:h-6 [&_.inline-icon-inner-1]:md:h-5 [&_.inline-media]:rounded-md [&_.inline-media]:overflow-hidden",
        (!env.admin || isGlobalBlock) && "flex flex-col gap-4 justify-center self-stretch",
        hasMedia &&
          "has-media justify-start [&_.inline-icon-inner]:h-5 [&_.inline-icon-inner]:md:h-4 [&_p]:type-body-m-mobile",
      )}
    >
      <InnerBlocks
        allowedBlocks={["#inline"]}
        adminClassName={cn(
          "flex flex-col gap-4 justify-center self-stretch h-full [&_p]:my-0 [&_h5]:my-0",
          hasMedia && "justify-start [&_.inline-icon-inner]:h-5 [&_.inline-icon-inner]:md:h-4",
        )}
        template={[
          ["content/inline-icon", {}],
          ["core/heading", { level: 5, placeholder: "Enter a title" }],
          ["core/paragraph", { placeholder: "Enter a description" }],
        ]}
      />
    </div>
  )
})
